/// Wrap a function and call the provided observer function when the function is called
export const observe = <T extends (...args: any[]) => any>(observed: T, observer: () => unknown): T =>
  ((...args: Parameters<T>) => {
    observer();
    return observed(...args);
  }) as any;
